<app-dialog [dialogWithInput]="dialog">
    <app-view-by-id-default
            [id]="dialog.input.id"
            [findByIdService]="findOneByIdService"
            (entityLoaded)="saleInvoiceLoaded($event)">
        <ng-container *ngIf="saleInvoice">
            <app-view-by-attribute
                    [value]="saleInvoice.sale.partner.account.businessCode"
                    [findByAttributeService]="findOneConfiguration"
                    (entityLoaded)="configurationLoaded($event)">
                <ng-container *ngIf="configuration">
                    <div class="row">
                        <div class="col-12">
                            <app-card-v2 title="E-mail">
                                <app-email-content-form
                                        [formatContentService]="formatContentActionService"
                                        [buildFormatContentPayload]="buildFormatContentPayload"
                                        [substitutionAdditionalCategoryValues]="['COMMUNICATION_CONTENT_SUBSTITUTION_CATEGORY_INVOICE',
                            'COMMUNICATION_CONTENT_SUBSTITUTION_CATEGORY_USER',
                            'COMMUNICATION_CONTENT_SUBSTITUTION_CATEGORY_PATIENT']"
                                        [formGroup]="contentFormGroup"
                                        [initialSubject]="initialSubject"
                                        [initialContent]="initialContent"
                                        [initialTo]="initialTo"
                                        [partnerId]="saleInvoice.sale.partner?.id"
                                        [canAddDocuments]="true">
                                </app-email-content-form>
                            </app-card-v2>
                        </div>
                        <div class="col-12">
                            <app-card-v2 title="Options">
                                <app-send-email-trigger-form [inCard]="false" [parentFormGroup]="triggerFormGroup"></app-send-email-trigger-form>
                            </app-card-v2>
                        </div>
                    </div>
                </ng-container>
            </app-view-by-attribute>
        </ng-container>
    </app-view-by-id-default>
    <app-action-button dialog-actions label="Envoyer" [service]="service"
                        [buildPayload]="buildPayload"
                        fill="solid"
                        (actionSuccessEvent)="sent()"
                        (actionErrorEvent)="notSent($event)"
                       [confirmationOptions]="undefined"
                        [disabled]="!formGroup.valid || !configuration">
    </app-action-button>
</app-dialog>
